import { render, staticRenderFns } from "./FormComp.vue?vue&type=template&id=47bdbf71"
import script from "./FormComp.vue?vue&type=script&lang=js"
export * from "./FormComp.vue?vue&type=script&lang=js"
import style0 from "./FormComp.vue?vue&type=style&index=0&id=47bdbf71&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports